$(document).ready(function(){
  $('#campaign-order-list').DataTable();
});
